import { LiveClassData } from '../initial.state';
import * as actionTypes from '../actions/types';

export const LiveClassesReducer = (state = new LiveClassData(), { type, response }) => {
  switch (type) {
    case actionTypes.GET_ALL_LIVE_CLASS_DATA:
      return {
        ...state,
        liveClasses: response.data.page,
        totalLiveClassesCount: response.data.totalItems,
      };
    case actionTypes.GET_ALL_ZOOM_ACCOUNTS:
      return { ...state, zoomAccounts: response.data.data };
    case actionTypes.GET_OCCUPIED_ZOOM_ACCOUNTS:
      return { ...state, occupiedZoomAccounts: response.data.data };
    case actionTypes.GET_ALL_BATCH_SUBJECTS:
      return { ...state, subjects: response.data.data };
    case actionTypes.GET_ALL_LIVE_BATCHES:
      return { ...state, batches: response.data.data };
    case actionTypes.GET_ALL_BATCH_CHAPTERS:
      return { ...state, chapters: response.data.data };
    case actionTypes.CREATE_BATCH_SUBJECT:
      return {
        ...state,
        subjects: [...state.subjects, response.data.data],
        newSubject: response.data.data,
      };
    case actionTypes.CREATE_BATCH_CHAPTER:
      return {
        ...state,
        chapters: [...state.chapters, response.data.data],
        newChapter: response.data.data,
      };

    case actionTypes.DELETE_BATCH_SUBJECT:
      return {
        ...state,
        subjects: state.subjects.filter(subject => subject.subjectId !== response),
      };

    case actionTypes.DELETE_BATCH_CHAPTER:
      return {
        ...state,
        chapters: state.chapters.filter(chapter => chapter.chapterId !== response),
      };
    case actionTypes.GET_ALL_TEACHERS:
      return {
        ...state,
        teacherList: response,
      };
    case actionTypes.GET_GROUP_LIST:
      return {
        ...state,
        groups: response.data.data.groupDTOS || [],
      };
    default:
      return state;
  }
};
